<template>
  <div>
    <!-- MODAL ADD TRAVAUX -->
    <v-dialog
      v-model="dialogAjoutTravaux"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span
              >Dupliquer les lots du type de chantier:
              {{ this.libelleSelect }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeForm()" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading">
          <v-layout row>
            <v-flex md3>
              <div class="block">
                <span class="demonstration">Type chantier *</span>
                <el-select
                  v-model="typeProjet"
                  placeholder="Selectionné un type projet"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in typeProjetTab"
                    :key="item.id"
                    :label="item.libelle"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </v-flex>
          </v-layout>
          <br />
          <el-form
            id="formLotTravaux"
            :rules="rulesLotTravaux"
            label-position="top"
            ref="formLotTravaux"
            :model="formLotTravaux"
            class="demo-ruleForm"
          >
            <v-layout row v-if="typeProjet !== ''">
              <v-flex xs1 mr-1>
                <el-form-item label="Ordre" prop="ordre">
                  <el-select
                    v-model="formLotTravaux.ordre"
                    placeholder="Select"
                  >
                    <el-option
                      v-for="(item, index) in numOrdre"
                      :key="index"
                      :label="item.num"
                      :value="item.num"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </v-flex>

              <v-flex xs3 mr-1>
                <el-form-item label="Libellé travaux" prop="libelle">
                  <el-input
                    placeholder="Saisir le libellé"
                    name="libelle"
                    v-model="formLotTravaux.libelle"
                  ></el-input>
                </el-form-item>
              </v-flex>

              <v-flex xs3 mr-1>
                <el-form-item label="Code" prop="code">
                  <el-input
                    placeholder="Code"
                    name="code"
                    v-model="formLotTravaux.code"
                  ></el-input>
                </el-form-item>
              </v-flex>

              <v-flex xs4 mr-1>
                <el-form-item label="Description" prop="description">
                  <el-input
                    type="textarea"
                    placeholder="description"
                    name="description"
                    :rows="6"
                    v-model="formLotTravaux.description"
                  ></el-input>
                </el-form-item>
              </v-flex>

              <v-flex xs1>
                <el-form-item label="Action">
                  <v-btn
                    icons
                    color="primary"
                    @click="addListeTypeTravaux()"
                    fab
                    small
                    dark
                  >
                    <v-icon>add</v-icon></v-btn
                  >
                </el-form-item>
              </v-flex>
            </v-layout>

            <div class="text-xs-right" v-if="typeProjet !== ''">
              <input
                name="fileInputExcel"
                type="file"
                style="display:none"
                ref="fileInputExcel"
                accept="image/*"
                @change="onFileExcelPicked"
              />
              <el-dropdown @command="handleFileExcel">
                <el-button type="success">
                  Fichier excel<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0"
                    >Importer fichier excel</el-dropdown-item
                  >
                  <el-dropdown-item command="1"
                    >Générer un modèle</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <br />

            <v-layout row wrap>
              <v-flex xs12>
                <el-table :data="listeLots" border style="width: 100%">
                  <el-table-column prop="ordre" label="Ordre">
                    <template slot-scope="prop">
                      <el-select
                        v-model="prop.row.ordre"
                        placeholder="Select"
                        @change="changeOrdre(prop.row.ordre, prop.$index)"
                      >
                        <el-option
                          v-for="(item, index) in listeNumber"
                          :key="index"
                          :label="item.num"
                          :value="item.num"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column prop="libelle" label="Libellé travaux">
                    <template slot-scope="prop">
                      <el-input
                        @change="handleChangeLibelle()"
                        controls-position="right"
                        size="small"
                        v-model="prop.row.libelle"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="code" label="Code">
                    <template slot-scope="prop">
                      <el-input
                        controls-position="right"
                        size="small"
                        v-model="prop.row.code"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="description" label="description">
                    <template slot-scope="prop">
                      <el-input
                        type="textarea"
                        controls-position="right"
                        size="small"
                        v-model="prop.row.description"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="Opérations" align="center">
                    <template slot-scope="scope">
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          fab
                          small
                          icons
                          color="red"
                          @click.native.prevent="
                            deleteRow(scope.$index, listeLots)
                          "
                          dark
                        >
                          <v-icon center>delete</v-icon>
                        </v-btn>
                        Supprimer ce lot
                      </v-tooltip>
                    </template>

                    <template slot-scope="scope">
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          fab
                          small
                          icons
                          color="red"
                          @click.native.prevent="
                            deleteRow(scope.$index, listeLots)
                          "
                          dark
                        >
                          <v-icon center>delete</v-icon>
                        </v-btn>
                        Modifier ce lot
                      </v-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </v-flex>

              <!--Bouton valider-->
              <v-flex xs12 sm12 align-self-end mt-4>
                <v-divider></v-divider>
                <v-layout row wrap>
                  <v-flex xs2 class="pr-1" offset-xs8>
                    <v-btn block @click="closeForm()" color="grey" dark
                      >Annuler <v-icon right>remove_circle</v-icon></v-btn
                    >
                  </v-flex>

                  <v-flex xs2 v-if="typeProjet != ''">
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        icons
                        block
                        color="green"
                        @click="submitDup()"
                        dark
                        >Enregistrer <v-icon right>save</v-icon></v-btn
                      >
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </el-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    <LoadTypeTravauxExcel
      @close="showModalLoadTypeTravaux = false"
      :show="showModalLoadTypeTravaux"
      :listeTypeTravaux="lstTypeTravaux"
      :idTypeProjet="this.typeProjet"
    ></LoadTypeTravauxExcel>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import LoadTypeTravauxExcel from "@/components/divers/loadTypeTravaux.vue";

export default {
  name: "formTypeTravaux",
  components: { Loading, LoadTypeTravauxExcel },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    listeLotTravaux: {
      type: Array,
      default: new Array()
    },
    typeProjetTab: {
      type: Array,
      default: new Array()
    },
    libelleSelect: {
      type: String,
      default: null
    },
    libelleChantier: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      loading: false,
      dialogAjoutTravaux: false,
      listeLots: [],
      typeProjet: "",
      formLotTravaux: {
        idTypeTrx: null,
        ordre: "",
        libelle: "",
        code: "",
        description: ""
      },
      rulesLotTravaux: {
        ordre: [
          {
            required: true,
            message: "Veuillez selectionnez un numéro d'ordre",
            trigger: "blur"
          }
        ],
        libelle: [
          {
            required: true,
            message: "Veuillez  saisir un type de travaux",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "Veuillez  saisir un code",
            trigger: "blur"
          }
        ]
      },
      numOrdre: [],
      numOrdreCopie: [],
      listeTrxSupp: [],
      showModalLoadTypeTravaux: false,

      //Importer fichier excel
      fileExcel: [],
      lstTypeTravaux: []
    };
  },
  watch: {
    show: function(newValue, oldValue) {
      if (newValue == true) {
        this.listeLots.splice(0);
        this.numOrdre.splice(0);
        this.typeProjet = "";
        this.dialogAjoutTravaux = true;
        this.numOrdre.push({ num: 1 });
        if (this.listeLotTravaux.length > 0) {
          this.numOrdre.splice(0);
          //rechechons lordre le plus eleve
          let ordreSup = null;
          this.listeLotTravaux.forEach((elt, ind) => {
            if (ind + 1 < this.listeLotTravaux.length) {
              let prochainOrdre = this.listeLotTravaux[ind + 1].ordre;
              if (prochainOrdre > elt.ordre) {
                ordreSup = prochainOrdre;
              } else {
                ordreSup = elt.ordre;
              }
            }
          });

          this.listeLots = this.listeLotTravaux.slice();

          this.numOrdreCopie.splice(0);
          let nbLots = this.listeLotTravaux.length;
          this.numOrdre.push({ num: ordreSup + 1 });

          if (this.listeLotTravaux.length == 1) {
            this.numOrdre.push({ num: 2 });
          }

          for (let i = 0; i <= nbLots; i++) {
            this.numOrdreCopie.push({ num: i + 1 });
          }
        }
      } else {
        this.dialogAjoutTravaux = false;
      }
    }
  },
  computed: {
    listeNumber: function() {
      let listeNum = this.numOrdreCopie.slice();
      return listeNum.filter(elt => {
        if (elt.num <= this.listeLots.length) {
          return elt;
        }
      });
    }
  },
  methods: {
    changeOrdre(value, ind) {},
    submitDup() {
      if (this.typeProjet == null) {
        this.$message.error("Aucun type de projet selectionne");
        return;
      }
      this.loading = true;

      let url = this.domaine + "projet/new/duplicate/travaux/projet";
      //recuperer les lots de travaux par groupe de 10
      let nbData = 1;
      if (this.listeLots.length > 10) {
        nbData = 10;
      }
      let nbReq = Math.round(this.listeLots.length / nbData);
      let nbRest = this.listeLots.length % nbData;
      if (nbRest > 0) {
        nbReq += 1;
      }
      if (nbReq == 0 && this.listeTrxSupp.length > 0) {
        nbReq = 1;
      }

      bloc_1: {
        for (let i = 0; i < nbReq; i++) {
          let initJ = i * nbData;
          let finJ = (i + 1) * nbData;
          let dataLot = [];
          dataLot.splice(0);
          if (this.listeLots.length > 0) {
            for (let j = initJ; j < finJ; j++) {
              if (this.listeLots[j] == undefined) {
                break;
              }
              dataLot.push(this.listeLots[j]);
            }
          }

          if (dataLot.length == 0 && this.listeTrxSupp.length == 0) {
            break bloc_1;
          }

          let data = new FormData();
          //envoie des donnees
          let ligne = null;
          for (let prop in dataLot) {
            ligne = dataLot[prop];
            data.append("option[ordre][]", ligne.ordre);
            data.append("option[idTypeTrx][]", ligne.idTypeTrx);
            data.append("option[libelle][]", ligne.libelle);
            data.append("option[code][]", ligne.code);
            data.append("option[description][]", ligne.description);
          }
          data.append("type", this.typeProjet);
          data.append("idUser", this.user.id);
          data.append("id", this.user.id);
          // data.append("lots", JSON.stringify(dataLot));
          data.append("listeSupp", JSON.stringify(this.listeTrxSupp));
          this.$http.post(url, data).then(
            response => {
              if (response.body.code == 1 && i == nbReq - 1) {
                this.$notify({
                  title: "Suppression travaux",
                  message: response.body.message + response.body.lstTrxNonSupp,
                  duration: 10000,
                  type: "warning"
                });
              }

              this.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Lot enregistré avec succès.",
                type: "success",
                position: "top-center"
              });
            },
            response => {
              this.$message.error(
                "Erreur lors de l'enregistrement des lots de travaux"
              );
              this.loading = false;
            }
          );
        }
      }

      this.loading = false;
      this.$emit("close");
    },
    closeForm() {
      this.$emit("close");
      this.typeProjet = "";
      this.resetForm();
    },
    deleteRow(index, rows) {
      let ordreIndex = this.listeLots[index].ordre;
      let indexpos = this.numOrdre.findIndex(elt => elt.num > ordreIndex);
      let indexposCopie = this.numOrdreCopie.findIndex(
        elt => elt.num == ordreIndex
      );

      this.numOrdre.splice(indexpos, 0, { num: ordreIndex });
      this.numOrdreCopie.splice(indexposCopie, 1);

      //enregistrer lid du lot de travaux supprimer dans la liste
      if (this.listeLots[index].idTypeTrx != null) {
        this.listeTrxSupp.push(this.listeLots[index].idTypeTrx);
      }

      rows.splice(index, 1);
      if (this.listeLots.length <= 0) {
        this.numOrdre.splice(0);
        this.numOrdreCopie.splice(0);

        this.numOrdre.push({ num: 1 });
        this.numOrdreCopie.push({ num: 1 });
      }
    },
    addListeTypeTravaux() {
      this.$refs["formLotTravaux"].validate(valid => {
        if (valid) {
          let lenListelot = this.listeLots.length;
          let indiceInsert = this.formLotTravaux.ordre - 1;
          this.listeLots.splice(indiceInsert, 0, {
            idTypeTrx: this.formLotTravaux.idTypeTrx,
            libelle: this.formLotTravaux.libelle,
            code: this.formLotTravaux.code,
            ordre: this.formLotTravaux.ordre,
            description: this.formLotTravaux.description
          });

          let index = this.numOrdre.findIndex(
            elt => elt.num == this.formLotTravaux.ordre
          );
          let dernierChif = this.numOrdre[this.numOrdre.length - 1].num;

          this.numOrdre.splice(index, 1);

          this.numOrdre.push({ num: dernierChif + 1 });
          this.resetForm();
        }
      });
    },
    handleChangeLibelle(newValue, oldValue) {
      if ((newValue = "")) {
        // this.$message({
        //     message: 'Ce champ ne peut etre vide',
        //     type: 'warning'
        // });
      }
    },
    handleFileExcel(
      command //0=>Importer,1=>generer
    ) {
      switch (command) {
        case "0": //importer un fichier
          this.$refs.fileInputExcel.click();
          break;
        case "1": //generer un modele un fichier
          this.generateFileExcel();
          break;
      }
    },
    generateFileExcel() {
      let url = this.domaine + "projet/generer/modele/travaux/projet";
      window.open(url);
    },
    onFileExcelPicked(event) {
      //  this.closeForm()
      this.fileExcel.splice(0, 1);
      const files = event.target.files;
      let filename = files[0].name;

      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.fileExcel.push(fileReader.result);
      });

      fileReader.readAsDataURL(files[0]);

      let url = this.domaine + "travaux/load_typeTravaux/excel";
      let data = new FormData();
      //emvoie du fichier

      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(
        resp => {
          this.loading = false;

          this.$notify({
            title: "Chargement liste type travaux",
            message: "Chargement effectué",
            type: "success",
            position: "top-right",
            duration: 7000
          });
          this.lstTypeTravaux = resp.body.listeTypeTravaux;
          this.showModalLoadTypeTravaux = true;
        },
        resp => {
          this.loading = false;
          this.$message.error("Erreur lors de l'importation du fichier");
        }
      );
    },
    resetForm() {
      this.$refs["formLotTravaux"].resetFields();
      this.formLotTravaux.libelle = "";
      this.formLotTravaux.code = "";
      this.formLotTravaux.description = "";
      this.listeTrxSupp.splice(0);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/divers/formdupplication/dupformTypeTravaux.vue